import React, { useState } from "react";
import { Link } from "react-scroll";
import { useSelector } from "react-redux";
import logo from "../assets/logo.png";

const Navbar = () => {
  const navItems = [
    { title: "Accueil", path: "/", isScroll: false },
    { title: "Accompagner", path: "accompagner", isScroll: true },
    { title: "Services", path: "services", isScroll: true },
    { title: "Tarifs", path: "tarifs", isScroll: true },
  ];


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const token = useSelector((state) => state.auth.token);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="fixed w-full bg-color1 z-20">
      <nav className="flex items-center container mx-auto px-4 sm:px-6 lg:px-10 h-20 lg:h-28">
        {/* Logo */}
        <div className="flex-shrink-0">
          <a href="/">
            <img
              src={logo}
              className="h-full w-auto max-h-20 lg:max-h-28"
              alt="gestion freelance"
            />
          </a>
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:flex flex-1 justify-center">
          <ul className="flex items-center gap-8 text-color2">
            {navItems.map(({ title, path, isScroll }) => (
              <li key={title} className="font-bold font-Poppins text-md hover:text-color3 cursor-pointer">
                {isScroll ? (
                  <Link to={path} smooth={true} duration={500} spy={true} offset={-80}>
                    {title}
                  </Link>
                ) : (
                  <a href={path}>{title}</a> // <-- Recharge la page pour Accueil
                )}
              </li>
            ))}
          </ul>

        </div>

        {/* Desktop buttons */}
        <div className="hidden lg:flex items-center gap-2 flex-shrink-0">

          <a
            href="/infleunceur"
            className="w-[180px] text-center font-bold font-Poppins text-md text-color2 "
          >
            Influenceur ?
          </a>
          {token ? (
            <a
              href="/EspaceClient"
              className="w-[180px] text-center font-bold font-Poppins text-md text-color2 bg-color1 border-[1px] rounded-lg px-3 py-2 hover:bg-color20 hover:text-color2 transition"
            >
              Ma Session
            </a>
          ) : (
            <a
              href="/login"
              className="w-[180px] text-center font-bold font-Poppins text-md text-color2 bg-color1 border-[1px] rounded-lg px-3 py-2 hover:bg-color20 hover:text-color2 transition"
            >
              Se connecter
            </a>
          )}

          <a
            href="newcompte"
            smooth={true}
            duration={500}
            offset={-80}
            className="w-[200px] text-center font-bold font-Poppins text-md text-color2 bg-color3 rounded-lg px-3 py-2 hover:bg-color3/45 hover:text-color2 transition cursor-pointer"
          >
            Création du compte
          </a>
        </div>

        {/* Mobile hamburger */}
        <div className="lg:hidden flex items-center ml-auto">
          <button onClick={toggleMenu} className="text-color2 focus:outline-none">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-color1 w-full absolute top-20 left-0 z-10">
          <ul className="flex flex-col items-center gap-4 py-6 text-color2">
            {navItems.map(({ title, path }) => (
              <li
                key={title}
                className="font-bold font-Poppins text-md hover:text-color3 cursor-pointer"
              >
                <Link
                  to={path}
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  onClick={closeMenu}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>

          <div className="flex flex-col items-center gap-3 mb-6">
            {token ? (
              <a
                href="/EspaceClient"
                className="w-[180px] text-center font-bold font-Poppins text-md text-color2 bg-color1 border-[1px] rounded-lg px-3 py-2 hover:bg-color20 hover:text-color2 transition"
              >
                Ma Session
              </a>
            ) : (
              <a
                href="/login"
                className="w-[180px] text-center font-bold font-Poppins text-md text-color2 bg-color1 border-[1px] rounded-lg px-3 py-2 hover:bg-color20 hover:text-color2 transition"
              >
                Se connecter
              </a>
            )}

            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-80}
              onClick={closeMenu}
              className="w-[180px] text-center font-bold font-Poppins text-md text-color2 bg-color3 rounded-lg px-3 py-2 hover:bg-color3/45 hover:text-color2 transition cursor-pointer"
            >
              Prendre rendez-vous
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
